import LoadingAnimation from 'components/LoadingAnimation';
import { observer } from 'mobx-react';
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSessionDetails } from 'scenes/SessionDetails/hooks/useSessionDetails';
import { ActiveView } from 'stores/store';
import { useStores } from 'stores/storeInitializer';
import { OtpGuard } from './components/OtpGuard';
import { DetailsPage } from './components/DetailsPage';

export const SessionDetails: React.FC = observer(() => {
    const { id, tenantId } = useParams<{
        id: string;
        tenantId: string;
    }>();
    const [searchParams] = useSearchParams();
    const locale = searchParams.get('locale');
    const { store } = useStores();
    useSessionDetails(id, tenantId);

    React.useLayoutEffect(() => {
        if (tenantId && id) {
            store.setLanguageContext(`session:${tenantId}:${id}`);
        }
    }, [id, store, tenantId]);

    React.useEffect(() => {
        store.applySuggestedLanguage(locale);
    }, [locale, store]);

    React.useEffect(() => {
        const interval = setInterval(() => {
            if (store.timer > 0) {
                store.setTimer(store.timer - 1);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [store, store.timer]);

    let activeComponent = <LoadingAnimation />;
    switch (store.activeView) {
        case ActiveView.Details:
            activeComponent = <DetailsPage />;
            break;
        case ActiveView.Otp:
            activeComponent = <OtpGuard />;
            break;
    }

    return activeComponent;
});

export default SessionDetails;
